import React, { useState,useEffect } from 'react';
import { Button, ButtonGroup, Card, CardBody, Row, Col, Label, Input } from 'reactstrap';
import UnitsDispensedTable from './UnitsDispensedTable';
import ErrorBoundary from "components/ErrorBoundary";
import useAxios from 'hooks/useAxios';
import { onExport, getUpdatedFilter } from 'utils/helper';

let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: '',
    order: '',
    filters: [],
  };
  
  let thirdPartyAdminDetails = {};
  
  let filtervalues = {}
  
  const UnitsDispensed = ({ tenantID, rowData }) => {
  
    const API = useAxios();
    const [state, updateState] = useState({
      data: [],
      coveredEntity: [],
      loading: false,
      selectedEntity: '',
      coveredId: '',
      records: 0,
      reset: false,
    });
    const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));
  
    useEffect(() => {
      initialFilters = {
        currentPage: 1,
        pageSize: 10,
        orderBy: '',
        order: '',
        filters: [],
      };
      setState({ data: [], records: 0 });
      if (rowData) {
        const { ndc, contractId, opaCode, npi } = rowData;
        if (ndc) {
          initialFilters.filters = getUpdatedFilter(
            'NDC',
            ndc,
            initialFilters
          );
        }
        if (opaCode) {
          initialFilters.filters = getUpdatedFilter(
            'CoveredEntity340BID',
            opaCode,
            initialFilters
          );
        }
        if (npi) {
          initialFilters.filters = getUpdatedFilter(
            'StoreNPI',
            parseInt(npi),
            initialFilters
          );
        }
        initialFilters.currentPage = 1;
        fetchUnitsDispensedData(initialFilters);
      }
  
    }, []);
  
    const fetchUnitsDispensedData = async (pageDetails = {}, hasColumnFilter) => {
      setState({ loading: true });
      let filter = { ...pageDetails };
      if (hasColumnFilter) {
        filter.filters = [...initialFilters.filters, ...pageDetails.filters];
        //initialFilters.filters = [...filter.filters];
      } else {
        initialFilters = { ...initialFilters, ...filter };
      }
      try {
        const { data } = await API.post(
          `/${tenantID}/Inventory/UnitsDispensed`, filter
        );
        if (data) {
          setState({
            data: data.items,
            records: data.totalRecords,
            loading: false,
          });
        } else {
          setState({
            data: [],
            records: 0,
            loading: false,
          });
        }
      } catch (error) {
        setState({ loading: false, data: [], records: 0 });
      }
    };
  
    const handleExport = () => {
      const { access_token } =
        JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
      const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Inventory/ExportUnitsDispensed?access_token=${access_token}`;
      onExport(action, initialFilters);
    };
  
    const onPageChange = (filter, hasFilter) => {
      if (hasFilter) {
        fetchUnitsDispensedData(filter, true);
      } else {
        fetchUnitsDispensedData(filter);
      }
    };
  
    const handleSearchColumnFilters = async (columnFilters) => {
      await fetchUnitsDispensedData({ ...initialFilters, ...columnFilters }, true);
    };
  
    const refetch = (hasReset) => {
      if (hasReset) {
        initialFilters = {
          ...initialFilters,
          currentPage: 1,
        };
      }
      fetchUnitsDispensedData(initialFilters);
    };

    return (
        <Card>
            <CardBody>
                <Row>
                    <Col >
                        <Row>
                            <Col md="2">
                            </Col>
                            <Col md="2">
                                <p className="m-0 f-14 float-end">NDC :</p>
                            </Col>
                            <Col md="2">
                                <p className="m-0 f-14 font-weight-500">{rowData?.ndc}</p>
                            </Col>
                            <Col md="2">
                            </Col>
                            <Col md="2">
                                <p className="m-0 f-14 float-end">Total Units Dispensed :</p>
                            </Col>
                            <Col md="2">
                                <p className="m-0 f-14 font-weight-500">{rowData?.accumulations}</p>
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col md="2">
                            </Col>
                            <Col md="2">
                                <p className="m-0 f-14 float-end">Drug Name :</p>
                            </Col>
                            <Col md="4">
                                <p className="m-0 f-14 font-weight-500">{rowData?.drugName}</p>
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col md="1" >
                            </Col>
                            <Col><p className="m-0 f-14 "><strong>Note:</strong> Only the most recent 500 records are visible to view. For all records please export.</p></Col>
                        </Row>
                    </Col>
                </Row>
            </CardBody>
            <CardBody className="border-top">
                <ErrorBoundary>
                    <UnitsDispensedTable
                        data={state.data}
                        loading={state.loading}
                        onExport={handleExport}
                        filters={initialFilters}
                        totalSize={state.records}
                        onPageChange={onPageChange}
                        setLoading={(value) => setState({ loading: value })}
                        refetch={refetch}
                        onSearchColumnFilters={handleSearchColumnFilters}
                        reset={state.reset}
                    />
                </ErrorBoundary>

            </CardBody>
        </Card>
    );
};

export default UnitsDispensed;
